const map = {
	"./cn/app.json": "./webpack-assets/vue/messages/common/cn/app.json",
	"./de/app.json": "./webpack-assets/vue/messages/common/de/app.json",
	"./en/app.json": "./webpack-assets/vue/messages/common/en/app.json",
	"./es/app.json": "./webpack-assets/vue/messages/common/es/app.json",
	"./fr/app.json": "./webpack-assets/vue/messages/common/fr/app.json",
	"./it/app.json": "./webpack-assets/vue/messages/common/it/app.json",
	"./ja/app.json": "./webpack-assets/vue/messages/common/ja/app.json",
	"./ko/app.json": "./webpack-assets/vue/messages/common/ko/app.json",
	"./nl/app.json": "./webpack-assets/vue/messages/common/nl/app.json",
	"./pl/app.json": "./webpack-assets/vue/messages/common/pl/app.json",
	"./pt/app.json": "./webpack-assets/vue/messages/common/pt/app.json",
	"./ru/app.json": "./webpack-assets/vue/messages/common/ru/app.json"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./webpack-assets/vue/messages/common sync recursive ^\\.\\/.*\\/app\\.json$";